import { ShapeIcon } from './ShapeIcon';

/**
 * author: Google
 * id B29246C8-6014-4019-8CCC-F803DBC0FA95
 * name shape
 * version: 2.1.19
 * url https://raw.githubusercontent.com/Templarian/MaterialDesign/master/svg/shape.svg
 * tags
 * - Shape 
 */
export const CategoryIcon = ShapeIcon;
export default CategoryIcon